/* ============================
   Location Utilities
   ============================ */

export const getLocation = () =>
    new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
            reject({ code: 2 });
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => resolve(position),
            reject,
            {
                enableHighAccuracy: true,
                timeout: 10000,
            }
        );
    });
